import React from 'react'
import { Col,Button,Input} from 'reactstrap';
import { Dialog } from 'primereact/dialog';


export const ModalCreateSite = (props) => {

// ? CONFIGURATION 
    const {modalSite,toggleSite,handleTextSite,saveCreateSite} = props;

    return (
        <Dialog 
            header="Crear nuevo sitio"
            visible={modalSite}
            onHide={toggleSite}
            headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold',
                }}
            pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
            className="pt-0 custom-dialog-img-sample"
            footer={
                <div>
                    <Button onClick={() => saveCreateSite()} color='secondary' type="button">{"Aceptar"}</Button>
                </div>
            }
        >
            <Col sm="12" className='pt-2' >
                <label className='label-dashboard' style={{color:"#565a5efc", fontWeight: "bold", fontSize:"15px"}}  >Nombre del sitio</label>
                <Input className="form-control" onChange={(e) => handleTextSite(e.target.value)}></Input>
            </Col>            
        </Dialog>
    )
}
       